module.exports = __webpack_public_path__ + "images/icons_v2/search-552b05da.svg";